import {
    FETCH_SCORING,
    SCORING_LOAD_BEGIN,
    SCORING_LOAD_END,
    SCORING_LOAD_ERROR,
    TOGGLE_SCORING,
    TOGGLE_SCORING_LOAD_BEGIN,
    TOGGLE_SCORING_LOAD_END,
    TOGGLE_SCORING_LOAD_ERROR,
} from '../actions/actionTypes';

const initialState = {
    items:                [],
    error:                null,
    toggleScoringError:   null,
    loading:              false,
    toggleScoringLoading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SCORING:
            return {
                ...state,
                items: action.payload.data
            };
        case TOGGLE_SCORING:
            return {
                ...state,
                isSiteSelected: action.payload
            };
        case SCORING_LOAD_BEGIN:
            return {
                ...state,
                error:   initialState.error,
                loading: true
            };
        case SCORING_LOAD_END:
            return {
                ...state,
                loading: false
            };
        case SCORING_LOAD_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case TOGGLE_SCORING_LOAD_BEGIN:
            return {
                ...state,
                error:                initialState.error,
                toggleScoringLoading: true
            };
        case TOGGLE_SCORING_LOAD_END:
            return {
                ...state,
                toggleScoringLoading: false
            };
        case TOGGLE_SCORING_LOAD_ERROR:
            return {
                ...state,
                toggleScoringError: action.payload
            };
        default:
            return state;
    }
};
